import React, { useEffect, useState } from 'react';
import AppInstallTemplate from './app-install-template';
import ReportTemplateV2 from '../reporting/components/ReportTemplateV2';
import { fetchAppInstallData } from '../hooks/useAppInstallData';

function AppInstallWrapper({ campaigns = [], ...props }) {
  const [data, setData]       = useState(null);
  const [error, setError]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ids = campaigns.map(c => c.id).filter(Boolean);
    if (!ids.length) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    fetchAppInstallData(ids)
      .then(result => setData(result))
      .catch(err   => setError(err.message))
      .finally(()  => setLoading(false));
  }, [campaigns.map(c => c.id).join(',')]); // eslint-disable-line

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:64, gap:12, fontFamily:'system-ui, sans-serif', color:'#6366f1' }}>
      <div style={{ width:24, height:24, border:'3px solid #e0e7ff', borderTop:'3px solid #6366f1', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
      <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
      Caricamento dati App Install...
    </div>
  );

  if (error) return (
    <div style={{ padding:24, background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, color:'#991b1b', fontSize:13, fontFamily:'system-ui, sans-serif' }}>
      Errore caricamento dati: {error}
      <div style={{ marginTop:16 }}>
        <strong>Fallback KPI da Generator:</strong>
        <ReportTemplateV2 {...props} campaigns={campaigns} />
      </div>
    </div>
  );

  if (!data) return (
    <div style={{ padding:24, color:'#888', fontSize:13, fontFamily:'system-ui, sans-serif' }}>
      Nessuna campagna selezionata.
    </div>
  );

  return <AppInstallTemplate data={data} />;
}

export const appInstall = {
  id: 'app-install',
  label: 'App Install',
  description: 'Report campagne App Install con breakdown piattaforma, dispositivo, regione e demografica',
  component: AppInstallWrapper,
  useV2: true,
  sections: [],
};
